import React from "react";
import { Avatar, CssBaseline, Typography, Container, Box } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

class SignOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    sessionStorage.clear();
  }

  render() {
    return (
      <Container component="main" maxWidth="xs" sx={{ pt: 12 }}>
        <CssBaseline />
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar sx={{ bgcolor: "primary.main", mb: 2 }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Du er nå logget ut av Avregning!
          </Typography>
        </Box>
      </Container>
    );
  }
}

export default SignOut;
